import React from 'react';
import {NewGoalRow, SelectedGoalRow} from './GoalRow';
import MessageDefinitions from '../i18n/MessageDefinitions';
import {FormattedMessage} from 'react-intl';
import FontAwesome from 'react-fontawesome';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

class GoalPanel extends React.Component {

  static propTypes = {
    /**
     * This key is used to lookup the goals that are currently selected.
     */
    goalTypesKey: PropTypes.string.isRequired,
    /**
     * This is used to determine what to add to the end of the goalType - for example vehicleAmountToBorrow - vehicle will be goalType.key, AmountToBorrow will be the qualifier used when saving the answer
     */
    qualifier: PropTypes.string.isRequired,

    /**
     * If provided, toggle will be treated as the "no need" answer.
     * This option will only show if you have not answered any other values.
     * In addition, if the toggle key is selected, it will not allow you to add any more goals.
     */
    toggle: PropTypes.string
  };

  state = {
    goals: this.props.initialGoals || [{}]
  };

  addGoal = () => {
    this.setState({
      goals: [
        ...this.state.goals,
        {}
      ]
    });
  };

  updateGoalTypes = goals => {
    const goalTypes = goals.filter(g => g.goalType).map(g => g.goalType.key);
    const {goalTypesKey} = this.props;

    this.props.answerService.saveAnswer({
      appkey: goalTypesKey,
      value: goalTypes,
      timestamp: new Date()
    });
  };

  removeValues = goalType => {
    const {qualifier} = this.props;
    this.props.answerService.removeAnswer(`${goalType.key}${qualifier}`);
    this.props.answerService.removeAnswer(`${goalType.key}Timing`);
  };

  validateGoalAmount = (goalType, amount) => {
    return goalType.max ? amount >= goalType.min && amount <= goalType.max : amount >= goalType.min
  };

  setValues = debounce(({goalType, amount, timing}) => {
    const {qualifier} = this.props;

    if (amount === '' || amount === undefined || !this.validateGoalAmount(goalType, amount)) {
      this.props.answerService.removeAnswer(`${goalType.key}${qualifier}`);
    } else {
      this.props.answerService.saveAnswer({
        appkey: `${goalType.key}${qualifier}`,
        value: amount,
        timestamp: new Date()
      });
    }

    if (!timing) {
      this.props.answerService.removeAnswer(`${goalType.key}Timing`);
    } else {
      this.props.answerService.saveAnswer({
        appkey: `${goalType.key}Timing`,
        value: timing,
        timestamp: new Date()
      });
    }
  }, 500);

  removeGoal = index => {
    const goals = this.state.goals;
    const goalToRemove = goals[index];

    goals.splice(index, 1);
    this.updateGoalTypes(goals);
    this.removeValues({
      goalType: goalToRemove.goalType
    });
    const finalGoals = goals.length ? [...goals] : [{}];
    this.setState({
      goals: [...finalGoals]
    });
  };

  render() {
    const {
      goalTypes,
      toggle
    } = this.props;
    const {
      goals
    } = this.state;

    const selectedGoalTypes = new Set(goals.filter(t => t.goalType).map(t => t.goalType.key));

    const allowedGoalTypes = goalTypes.filter(({key}) => {
      if (key === toggle) {
        return selectedGoalTypes.size === 0;
      } else {
        return !selectedGoalTypes.has(key);
      }
    });

    const renderedGoals = goals.map((goal, index) => {
      const goalChanged = (e, {amount, timing}) => {
        goal.amount = amount;
        goal.timing = timing;
        this.setState({
          goals: [...goals]
        });
        this.setValues({
          goalType: goal.goalType,
          amount,
          timing
        });
      };
      const goalTypeChanged = (value) => {
        goal.goalType = goalTypes.find(g => g.key === value);
        if (value === toggle) {
          const newGoals = [goal];
          goalTypes.filter(g => g.key !== toggle).forEach(this.removeValues);
          this.updateGoalTypes(newGoals);
          this.setState({
            goals: newGoals
          });
        } else {
          const newGoals = [...goals];
          this.updateGoalTypes(newGoals);
          this.setState({
            goals: newGoals
          });
        }
      };
      const goalRemoved = () => {
        this.removeGoal(index);
      };
      const {goalType} = goal;
      return goalType ?
        <SelectedGoalRow
          {...goal}
          key={index}
          onChange={goalChanged}
          onRemove={goalRemoved}
          isToggle={goalType.key === toggle}
        /> :
        <NewGoalRow
          key={index}
          goalTypes={allowedGoalTypes}
          onChange={goalTypeChanged}
          onRemove={goalRemoved}
        />
    });
    const classes = classnames({
      'goals-panel': true
    });

    const toggleSelected = goals.find(({goalType = {}}) => goalType.key === toggle);

    const newButton = (
      goals.length < goalTypes.filter(g => g.key !== toggle).length &&
      !toggleSelected
    ) ? <div className="text-center">
        <button className="btn btn-secondary new" onClick={this.addGoal}>
          <FormattedMessage {...MessageDefinitions.addGoal} />
          <FontAwesome name="plus"/>
        </button>
    </div> : null;

    return <div className={classes}>
      {renderedGoals}
      {newButton}
    </div>;
  }
}

export default GoalPanel;



/** WEBPACK FOOTER **
 ** ./src/main/js/goalBuilder/components/GoalPanel.js
 **/